import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timer"]
  static values = {
    expiresAt: String
  }

  connect() {
    console.log('PIX Countdown controller connected')
    console.log('Expires at value:', this.expiresAtValue)
    console.log('Has expires at value:', this.hasExpiresAtValue)

    if (!this.hasExpiresAtValue) {
      console.log('No expiration date provided')
      if (this.hasTimerTarget) {
        this.timerTarget.textContent = "Data não disponível"
      }
      return
    }

    this.updateCountdown()
    this.interval = setInterval(() => this.updateCountdown(), 1000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateCountdown() {
    const now = new Date()
    const expiresAt = new Date(this.expiresAtValue)
    const diff = expiresAt - now

    if (diff <= 0) {
      this.showExpired()
      this.stopCountdown()
      return
    }

    const hours = Math.floor(diff / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`

    if (this.hasTimerTarget) {
      this.timerTarget.textContent = timeString

      // Change color when less than 5 minutes
      if (diff < 5 * 60 * 1000) {
        this.timerTarget.classList.add('text-red-600', 'font-bold')
      }
    }
  }

  showExpired() {
    if (this.hasTimerTarget) {
      this.timerTarget.textContent = "EXPIRADO"
      this.timerTarget.classList.add('text-red-600', 'font-bold')
    }

    // Show expired message to user
    const container = this.element.querySelector('.bg-amber-50')
    if (container) {
      container.classList.remove('bg-amber-50', 'border-amber-200')
      container.classList.add('bg-red-50', 'border-red-200')

      const icon = container.querySelector('svg')
      if (icon) {
        icon.classList.remove('text-amber-600')
        icon.classList.add('text-red-600')
      }

      const textElements = container.querySelectorAll('.text-amber-800, .text-amber-700')
      textElements.forEach(el => {
        el.classList.remove('text-amber-800', 'text-amber-700')
        el.classList.add('text-red-800')
      })
    }
  }

  stopCountdown() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }
}
